import "./PreloadedQuestions.scss";
import React, { useEffect, useRef } from "react";
import Avatar from "../Avatar";

export default function PreloadedQuestions({
  isActive,
  minimizeAll,
  askQuestion,
  questions,
  welcome,
}) {
  const rootRef = useRef(null);
  // Interactive when open or showing the teaser; otherwise out of tab order / AT.
  const hidden = !(isActive === true || isActive === "half-minimized");

  useEffect(() => {
    if (rootRef.current) {
      rootRef.current.inert = hidden;
      rootRef.current.setAttribute("aria-hidden", hidden ? "true" : "false");
    }
  }, [hidden]);

  return (
    <div
      ref={rootRef}
      className={
        "PreloadedQuestions" +
        (isActive === "half-minimized"
          ? " half-minimized"
          : isActive
            ? ""
            : " minimized")
      }
    >
      <div className="intro">
        <div className="intro-avatar">
          <Avatar size={40} />
        </div>
        <div className="intro-text">
          {welcome || "Greetings - I'm an AI Chatbot that answers questions based on our published research & insights."}
        </div>
        <button
          type="button"
          className="close-btn"
          aria-label="Dismiss"
          onClick={minimizeAll}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <div className="questions">
        {questions.length > 0 ? (
          questions.map((textPrompt, i) => (
            <button key={i} onClick={() => askQuestion(textPrompt)}>
              {textPrompt}
            </button>
          ))
        ) : (
          <div className="thinking-dots">
            <svg height="20" width="40">
              <circle className="dot" cx="10" cy="10" r="3" />
              <circle className="dot" cx="20" cy="10" r="3" />
              <circle className="dot" cx="30" cy="10" r="3" />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
}
